import SubDomainsListComponent from './SubDomainsListComponent';

export default SubDomainsListComponent;
